import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { ButtonProps } from "sprint-common-web";

import { movieAssetsListRoute } from "../../../../../assets/AssetsRoutes";
import { ViewAssetButton } from "../../../../common/components/ViewAssetButton";
import { MovieVersionListingContext } from "../context/MovieVersionListingContext";

interface ViewMovieVersionAssetButtonProps extends ButtonProps {
    itemId?: string;
    item: { typeId?: string };
}

export const ViewMovieVersionAssetButton: React.FunctionComponent<ViewMovieVersionAssetButtonProps> = (
    props: ViewMovieVersionAssetButtonProps
) => {
    const history = useHistory();
    const { movieDetails } = useContext(MovieVersionListingContext);

    const handleClick = () => {
        if (props.item.typeId) {
            moveToMovieAssets(props.item.typeId);
        }
    };

    const moveToMovieAssets = (movieVersionId: string) => {
        const basePath = movieAssetsListRoute.path;
        const requiredPath = basePath?.slice(0, basePath.lastIndexOf("/"));
        history.push(`${requiredPath}/${movieDetails.id}?versionTypeIds.0=${movieVersionId}`);
    };

    return <ViewAssetButton disabled={props.disabled} onClick={handleClick} />;
};
